import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "calendar-month-container" }
const _hoisted_2 = { class: "calendar-weekdays-container" }
const _hoisted_3 = { class: "calendar-month-week-column flex start-xs col" }

import { computed } from 'vue';
import { getWeekArray } from '../util/dateUtils';
import WeekRow from './WeekRow.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarMonth',
  props: {
  dates: {
    type: Array<Date>,
    default: [],
  },
  minDate: {
    type: Date,
    required: true,
  },
  maxDate: {
    type: Date,
    required: true,
  },
  displayDate: {
    type: Date,
    required: true,
  },
  firstDayOfWeek: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props



const weekArray = computed(() => {
  return getWeekArray(props.displayDate, props.firstDayOfWeek);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(weekArray), (week, index) => {
          return (_openBlock(), _createBlock(WeekRow, {
            week: week,
            key: index,
            minDate: __props.minDate,
            maxDate: __props.maxDate,
            dates: __props.dates
          }, null, 8, ["week", "minDate", "maxDate", "dates"]))
        }), 128))
      ])
    ])
  ]))
}
}

})